import { getZonedDate } from '@eika-infrastruktur/date';

import { RecurringPaymentAction, RecurringPaymentActionType } from './actions';
import { recurringPaymentInitialState, RecurringPaymentState } from './state';

const recurringPaymentReducer = (
    state: RecurringPaymentState,
    action: RecurringPaymentAction,
): RecurringPaymentState => {
    switch (action.type) {
        case RecurringPaymentActionType.FROM_ACCOUNT_SELECTED:
            return {
                ...state,
                fromAccount: action.payload,
            };
        case RecurringPaymentActionType.TO_ACCOUNT_SELECTED:
            return {
                ...state,
                toAccount: action.payload,
            };
        case RecurringPaymentActionType.AMOUNT:
            return {
                ...state,
                amount: action.payload,
            };
        case RecurringPaymentActionType.NOTE:
            return {
                ...state,
                note: action.payload,
            };
        case RecurringPaymentActionType.OWNTEXT:
            return {
                ...state,
                ownText: action.payload,
            };
        case RecurringPaymentActionType.FIRST_PAYMENT_DATE:
            return {
                ...state,
                firstPaymentDate: getZonedDate(action.payload),
            };
        case RecurringPaymentActionType.LAST_PAYMENT_DATE:
            return {
                ...state,
                lastPaymentDate: action.payload ? getZonedDate(action.payload) : undefined,
            };
        case RecurringPaymentActionType.FIRST_BANKING_DATE:
            return {
                ...state,
                firstBankingDate: action.payload,
                firstPaymentDate: action.payload,
            };
        case RecurringPaymentActionType.ONLY_BANKING_DATE:
            return {
                ...state,
                firstBankingDate: action.payload,
            };
        case RecurringPaymentActionType.PAYMENT_INTERVAL:
            return {
                ...state,
                paymentInterval: action.payload,
            };
        case RecurringPaymentActionType.RESET:
            return {
                ...recurringPaymentInitialState,
                firstBankingDate: state.firstBankingDate,
                firstPaymentDate: state.firstBankingDate,
            };
        case RecurringPaymentActionType.SHOW_FROM_ACCOUNTS:
            return {
                ...state,
                showFromAccounts: true,
            };
        case RecurringPaymentActionType.HIDE_FROM_ACCOUNTS:
            return {
                ...state,
                showFromAccounts: false,
            };
        default:
            return state;
    }
};

export default recurringPaymentReducer;
